export const MATURITY_STYLE = {
  compromis: "bg-emerald-100 text-emerald-800",
  offre_en_cours: "bg-teal-100 text-teal-800",
  en_recherche: "bg-sky-100 text-sky-800",
  en_reflexion: "bg-indigo-100 text-indigo-800",
  premier_contact: "bg-slate-100 text-slate-700",
};
export const MATURITY_FR = { compromis: "Sous compromis", offre_en_cours: "Offre d'achat effectuée", en_recherche: "En recherche active", en_reflexion: "En réflexion", premier_contact: "Premier contact" };
export const MATURITY_ORDER = ["compromis", "offre_en_cours", "en_recherche", "en_reflexion", "premier_contact"];
export const STRATEGY_FR = { conserve: "Conservation recommandée", distribue: "Distribution recommandée" };

export function MaturityBadge({ maturiteKey, label, testId = "mk-maturite" }) {
  return (
    <span className={`text-[11px] font-extrabold uppercase tracking-wide rounded-md px-2 py-1 ${MATURITY_STYLE[maturiteKey] || MATURITY_STYLE.premier_contact}`} data-testid={testId}>
      {label || MATURITY_FR[maturiteKey] || maturiteKey}
    </span>
  );
}

export function StrategyChip({ strategy, label, testId = "mk-strategy" }) {
  const cls = strategy === "conserve" ? "border-amber-300 text-amber-800 bg-amber-50" : "border-emerald-300 text-emerald-800 bg-emerald-50";
  return <span className={`text-[11px] font-bold rounded-full border px-2 py-0.5 ${cls}`} data-testid={testId}>{label || STRATEGY_FR[strategy] || strategy}</span>;
}
